<!--
  - ===========================================================================
  - [StrongGate Limited] [http://www.stronggate.com]
  - Copyright (c) 2025. All rights Reserved.
  - Unauthorized access, use, dissemination, distribution, reproduction of this
  - file, or a portion of, in any form is prohibited and unlawful. If you receive
  - this file, and you are not an authorized company employee, or you believe you
  - have received this file in error, please notify the sender (or originator)
  - and promptly delete this file.
  -
  - Project:
  - File: SidebarMenuItem.vue
  - Created by: chan.ying
  - Create Date: 2025-08-01 16:43
  - Version Number: 1.0
  - Version Description:
  -
  - =============================================================================
  -->

<template>
  <li>
    <div
        v-if="item.type === 'load-more'"
        class="submenu-link submenu-item load-more"
        :style="{ marginLeft: `${level * 32}px` }"
        @click.stop="handleLoadMore(item)"
    >
      ...
    </div>

    <router-link
        v-else-if="!hasSubItems"
        :to="item.link"
        class="submenu-link"
        :class="{ active: isActive(item) }"
    >
      <div class="ztn-page-t400 mb-2" :style="{ marginLeft: `${level * 32}px` }">
        <template v-if="item.type === 0">
          {{ $t(item.label) }}
        </template>
        <template v-else>
          {{ item.label }}
        </template>
      </div>
    </router-link>

    <div v-else>
      <div class="menu-header" :class="{ active: isParentActive(item) }">
        <router-link :to="item.link" class="ztn-submenu-link">
          <div class="ztn-page-t400 mb-2" :style="{ marginLeft: `${level * 32}px` }">
            <template v-if="item.type === 0">
              {{ $t(item.label) }}
            </template>
            <template v-else>
              {{ item.label }}
            </template>
          </div>
        </router-link>
        <img
            class="arrow"
            @click.stop="toggleSubMenu"
            :class="{ rotated: isOpen }"
            src="@/assets/icons/menu/chevron-up.svg"
            alt=""
        />
      </div>
      <!--      <transition name="submenu">-->
      <ul v-if="isOpen" class="submenu">
        <sidebar-menu-item
            v-for="subItem in item.subItems"
            :key="subItem.id"
            :item="subItem"
            :level="level + 0.8"
            :onLoadMore="onLoadMore"
        />
      </ul>
      <!--      </transition>-->
    </div>
  </li>
</template>

<script>
import SidebarMenuItem from "@/components/sidebar-menu-item.vue";

export default {
  name: 'sidebar-menu-item',
  components: {SidebarMenuItem},
  props: {
    item: Object,
    level: {
      type: Number,
      default: 1
    },
    onLoadMore: {type: Function}
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    hasSubItems() {
      return this.item.subItems && this.item.subItems.length > 0;
    },
  },
  methods: {
    handleLoadMore(item) {
      if (typeof this.onLoadMore === 'function') {
        const parent = item.__parentRef || this.item.__parentRef || null;
        this.onLoadMore(parent || this.item);
      }
    },
    toggleSubMenu() {
      this.isOpen = !this.isOpen;
    },
    getLinkPrefix(path) {
      const parts = path.split('/');
      return parts.length > 1 ? `/${parts[1]}` : '/';
    },
    isActive(item) {
      if (item.type === 1) {
        return this.$route.path === item.link;
      }
      const currentPrefix = this.getLinkPrefix(this.$route.path);
      const linkPrefix = this.getLinkPrefix(item.link);
      if (currentPrefix && linkPrefix) {
        return currentPrefix === linkPrefix;
      }
      return this.$route.path === item.link;
    },
    isParentActive(item) {
      return this.isActive(item) ||
          (item.subItems && item.subItems.some(subItem => this.isActive(subItem)));
    }
  },
  mounted() {
    if (this.hasSubItems && this.isParentActive(this.item)) {
      this.isOpen = true;
    }
  },
  watch: {
    '$route'() {
      if (this.hasSubItems && this.isParentActive(this.item)) {
        this.isOpen = true;
      }
    },
  },
};
</script>

<style scoped>
.submenu-link {
  display: flex;
  align-items: center;
  padding: var(--space-3) var(--space-4);
  cursor: pointer;
  position: relative;
  transition: background-color 0.3s, color 0.3s;
}

.submenu-link.active {
  position: relative;
  color: var(--sidebar-primary);
  font-weight: bold;
}

.submenu-link.active::before {
  content: "";
  position: absolute;
  left: 0;
  top: 25%;
  bottom: 25%;
  width: 5px;
  background-color: var(--sidebar-primary);
}

.menu-header.active .ztn-page-t400 {
  color: var(--sidebar-primary);
}

.ztn-submenu-link {
  display: flex;
  color: var(--body-color-1);
  align-items: center;
  cursor: pointer;
  position: relative;
  transition: background-color 0.3s, color 0.3s;
}

.ztn-submenu-link.active {
  color: var(--sidebar-primary);
}
</style>